import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardCustomerService } from './guards/auth-guard-customer.service';
import { AuthGuardLoginService } from './guards/auth-guard-login.service';
import { AuthGuardService } from './guards/auth-guard.service';

const routes: Routes = [

  {
    path: '',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    data:{
      reuse: true
    }
  },
  {
    path: "demo",
    pathMatch: "full",
    redirectTo: "login/demo"
  },
  {
    path: "login",
    canActivate: [AuthGuardLoginService],
    loadChildren: ()=> import('./_pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: "login/:param",
    canActivate: [AuthGuardLoginService],
    loadChildren: ()=> import('./_pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'ticket-detail-page',
    loadChildren: () => import('./_pages/ticket-detail-page/ticket-detail-page.module').then( m => m.TicketDetailPagePageModule)
  },
  {
    path: 'crm-detail-page',
    loadChildren: () => import('./_pages/crm-detail-page/crm-detail-page.module').then( m => m.CrmDetailPagePageModule)
  },
  {
    path: 'appointment-page',
    loadChildren: () => import('./_pages/calendar/appointment-page/appointment-page.module').then( m => m.AppointmentPagePageModule)
  },
  {
    path: 'multiple-content',
    loadChildren: () => import('./_template/ticket-detail/multiple-content/multiple-content.module').then( m => m.MultipleContentPageModule)
  },
  {
    path: 'article',
    loadChildren: () => import('./_pages/article/article.module').then( m => m.ArticlePageModule)
  },
  {
    path: 'ticket-select',
    loadChildren: () => import('./_pages/ticket-select/ticket-select.module').then( m => m.TicketSelectPageModule)
  },
  {
    path: 'no-connection',
    loadChildren: () => import('./_pages/no-connection/no-connection.module').then( m => m.NoConnectionPageModule)
  },
  {
    path: 'attachments',
    loadChildren: () => import('./_pages/attachments/attachments.module').then( m => m.AttachmentsPageModule)
  },
  {
    path: 'image-view',
    loadChildren: () => import('./_pages/image-view/image-view.module').then( m => m.ImageViewPageModule)
  },
  {
    path: 'pdf-viewer',
    loadChildren: () => import('./_pages/pdf-viewer/pdf-viewer.module').then( m => m.PdfViewerPageModule)
  },
  {
    path: 'ticket/:action/:id',
    loadChildren: () => import('./_pages/universal-link/universal-link.module').then( m => m.UniversalLinkPageModule)
  },
  {
    path: 'new-features',
    loadChildren: () => import('./_pages/new-features/new-features.module').then( m => m.NewFeaturesPageModule)
  },
  {
    path: 'password-recovery/:tokenheader/:tokenpayload/:tokensignature',
    loadChildren: () => import('./_pages/password-recovery/password-recovery.module').then( m => m.PasswordRecoveryPageModule)
  },
  {
    path: 'customer',
    canActivate: [AuthGuardCustomerService],
    loadChildren: () => import('./_pages/customer-main/customer-main.module').then( m => m.CustomerMainPageModule)
  },
  {
    path: 'customer-main-mobile',
    loadChildren: () => import('./_pages/customer-main/customer-main-mobile/customer-main-mobile.module').then( m => m.CustomerMainMobilePageModule)
  },
  {
    path: 'contact-person-detail',
    loadChildren: () => import('./_template/crm-detail/contact-person-detail/contact-person-detail.module').then( m => m.ContactPersonDetailPageModule)
  },
  {
    path: 'partylicenses',
    loadChildren: () => import('./_pages/login/partylicenses/partylicenses.module').then( m => m.PartylicensesPageModule)
  },
  {
    path: 'qrscanner',
    loadChildren: () => import('./_pages/qrscanner/qrscanner.module').then( m => m.QrscannerPageModule)
  },
  {
    path: 'ticket-tab/:ticketid',
    loadChildren: () => import('./_pages/ticket-tab/ticket-tab.module').then( m => m.TicketTabPageModule)
  },
  {
    path: 'boards',
    loadChildren: () => import('./_pages/boards/board-single-page/board-single-page.module').then( m => m.BoardSinglePagePageModule)
  },
  {
    path: "**",
    pathMatch: "full",
    loadChildren: () => import('./_pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundPageModule)
  },
  {
    path: 'subscription-user-amount',
    loadChildren: () => import('./_pages/new-settings/subscription/subscription-user-amount/subscription-user-amount.module').then( m => m.SubscriptionUserAmountPageModule)
  },
  {
    path: 'subscription-model',
    loadChildren: () => import('./_pages/new-settings/subscription/subscription-model/subscription-model.module').then( m => m.SubscriptionModelPageModule)
  },
  {
    path: 'subscription-invoices',
    loadChildren: () => import('./_pages/new-settings/subscription/subscription-invoices/subscription-invoices.module').then( m => m.SubscriptionInvoicesPageModule)
  },
  {
    path: 'ticket-art-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/ticket-art-edit/ticket-art-edit.module').then( m => m.TicketArtEditPageModule)
  },
  {
    path: 'contact-art-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/contact-art-edit/contact-art-edit.module').then( m => m.ContactArtEditPageModule)
  },
  {
    path: 'contact-art-overview',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/contact-art-overview/contact-art-overview.module').then( m => m.ContactArtOverviewPageModule)
  },
  {
    path: 'ticket-status-overview',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/ticket-status-overview/ticket-status-overview.module').then( m => m.TicketStatusOverviewPageModule)
  },
  {
    path: 'ticket-status-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/ticket-status-edit/ticket-status-edit.module').then( m => m.TicketStatusEditPageModule)
  },
  {
    path: 'ticket-number-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/ticket-number-edit/ticket-number-edit.module').then( m => m.TicketNumberEditPageModule)
  },
  {
    path: 'customer-edit',
    loadChildren: () => import('./_pages/new-settings/employee-manager/employee-edit/employee-edit.module').then( m => m.CustomerEditPageModule)
  },
  {
    path: 'employee-groups',
    loadChildren: () => import('./_pages/new-settings/employee-manager/employee-groups/employee-groups.module').then( m => m.EmployeeGroupsPageModule)
  },
  {
    path: 'employee-groups-edit',
    loadChildren: () => import('./_pages/new-settings/employee-manager/employee-groups-edit/employee-groups-edit.module').then( m => m.EmployeeGroupsEditPageModule)
  },
  {
    path: 'customer-login-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/customer-login-edit/customer-login-edit.module').then( m => m.CustomerLoginEditPageModule)
  },
  {
    path: 'ticket-report-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/ticket-report-edit/ticket-report-edit.module').then( m => m.TicketReportEditPageModule)
  },
  {
    path: 'ticket-report-edit-preview',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/ticket-report-edit/ticket-report-edit-preview/ticket-report-edit-preview.module').then( m => m.TicketReportEditPreviewPageModule)
  },
  {
    path: 'task-template-overview',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/task-template-overview/task-template-overview.module').then( m => m.TaskTemplateOverviewPageModule)
  },
  {
    path: 'task-template-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/task-template-edit/task-template-edit.module').then( m => m.TaskTemplateEditPageModule)
  },
  {
    path: 'crm-edit',
    loadChildren: () => import('./_pages/crm/crm-edit/crm-edit.module').then( m => m.CrmEditPageModule)
  },
  {
    path: 'tag-overview',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/tag-overview/tag-overview.module').then( m => m.TagOverviewPageModule)
  },
  {
    path: 'tag-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/tag-overview/tag-edit/tag-edit.module').then( m => m.TagEditPageModule)
  },
  {
    path: 'criticism',
    loadChildren: () => import('./_interfaces/navigation/criticism/criticism.module').then( m => m.CriticismPageModule)
  },
  {
    path: 'local-client-errors',
    loadChildren: () => import('./_pages/new-settings/local-client-errors/local-client-errors.module').then( m => m.LocalClientErrorsPageModule)
  },
  {
    path: 'openai-edit',
    loadChildren: () => import('./_pages/new-settings/ticket-settings/openai-edit/openai-edit.module').then( m => m.OpenaiEditPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./_pages/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'board-template-edit',
    loadChildren: () => import('./_pages/boards/board-template-edit/board-template-edit.module').then( m => m.BoardTemplateEditPageModule)
  },
  {
    path: 'content-text-module',
    loadChildren: () => import('./_template/ticket-detail/content-edit-popup/content-text-module/content-text-module.module').then( m => m.ContentTextModulePageModule)
  },
  {
    path: 'content-text-module-edit',
    loadChildren: () => import('./_template/ticket-detail/content-edit-popup/content-text-module/content-text-module-edit/content-text-module-edit.module').then( m => m.ContentTextModuleEditPageModule)
  },
  {
    path: 'content-text-module-preview',
    loadChildren: () => import('./_template/ticket-detail/content-edit-popup/content-text-module/content-text-module-preview/content-text-module-preview.module').then( m => m.ContentTextModulePreviewPageModule)
  },
  {
    path: 'calendar-edit-popover',
    loadChildren: () => import('./_pages/calendar/calendar-edit-popover/calendar-edit-popover.module').then( m => m.CalendarEditPopoverPageModule)
  },
  {
    path: 'global-config-informations',
    loadChildren: () => import('./_pages/global-config-informations/global-config-informations.module').then( m => m.GlobalConfigInformationsPageModule)
  },
  {
    path: 'process-detail',
    loadChildren: () => import('./_template/crm-detail/process-list/process-detail/process-detail.module').then( m => m.ProcessDetailPageModule)
  },
  {
    path: 'device-select',
    loadChildren: () => import('./_pages/device-select/device-select.module').then( m => m.DeviceSelectPageModule)
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}



